<template>
  <v-form @submit.prevent="updateCrmUser">
    <v-container>
      <v-row>
        <v-col md="12">
          <vue-user :user="actionData.user"></vue-user>
        </v-col>
        <v-col md="6">
          <v-select
            v-model="formValues.user_type"
            :items="crmUserTypes"
            label="Type of User"
          ></v-select>
        </v-col>
        <v-col md="6">
          <v-select
            v-model="organizationSlugs"
            label="Applicable on Organizations"
            :items="crmOrganizations()"
            item-text="name"
            item-value="slug"
            multiple
          ></v-select>
        </v-col>
        <div v-if="getOrganizationInfo(orgSlug)">
          fix this
        </div>
        <v-col
          v-for="(orgSlug, index) in organizationSlugs"
          :key="index"
          md="6"
        >
          <div class="font-weight-bold">
            {{ getOrganizationInfo(orgSlug) }}
          </div>
          <div class="d-inline-flex">
            <v-switch
              v-model="crmAdmin"
              :label="`CRM Admin`"
              :value="orgSlug"
              class="mx-3"
              multiple
            ></v-switch>
            <v-switch
              v-model="dealVerifier"
              :label="`Deal Verifier`"
              :value="orgSlug"
              class="mx-3"
              multiple
            ></v-switch>
          </div>
        </v-col>
      </v-row>
      <v-footer fixed height="60">
        <v-row>
          <v-col md="10" offset-md="1">
            <v-btn class="primary" type="submit">
              Save
            </v-btn>
            <v-btn type="reset">
              Reset
            </v-btn>
          </v-col>
        </v-row>
      </v-footer>
    </v-container>
  </v-form>
</template>
<script>
export default {
  props: {
    actionData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formValues: { ...this.actionData },
      crmUserTypes: ["Management", "Sales Lead", "Sales Person", "Associates"],
      organizationSlugs: [],
      crmAdmin: [],
      dealVerifier: []
    };
  },
  computed: {
    organizations() {
      return this.$store.state.shell.switchableOrganizations;
    },
    organizationSpecificData() {
      const finalArray = [];
      const self = this;
      this.organizationSlugs.forEach(function(val) {
        const isAdmin = self.crmAdmin.includes(val);
        const dealVerifier = self.dealVerifier.includes(val);
        finalArray.push({
          organization: val,
          deal_verifier: dealVerifier,
          is_admin: isAdmin
        });
      });
      return finalArray;
    }
  },
  mounted() {
    this.organizationSlugs = this.actionData.organizations.map(
      x => x.organization.slug
    );
    const self = this;
    this.actionData.organizations.forEach(function(val) {
      if (val.deal_verifier) {
        self.dealVerifier.push(val.organization.slug);
      }
      if (val.is_admin) {
        self.crmAdmin.push(val.organization.slug);
      }
    });
  },
  methods: {
    crmOrganizations() {
      return this.organizations.map(x => x.organization);
    },
    async updateCrmUser() {
      const patchURL = "/api/v1/crm/users/" + this.actionData.id + "/";
      this.formValues.user = this.actionData.user.id;
      this.formValues.organizations = this.organizationSlugs;
      this.formValues.organizations_data = this.organizationSpecificData;
      this.$axios
        .$patch(patchURL, this.formValues)
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `CRM user successfully updated.`,
            color: "green"
          });
          this.$emit("crmUserUpdateFormResponse");
        })
        .catch(error => {
          // this.notifyInvalidFormResponse();
          return error;
        });
    },
    getOrganizationInfo(slug) {
      try {
        const organizations = this.crmOrganizations();
        return organizations.find(x => x.slug === slug).name;
      } catch (err) {
        return err;
      }
    }
  }
};
</script>
